export default "__VITE_ASSET__CJSMD0Mi__"